/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefreshTokenMutationVariables = Types.Exact<{
	username?: Types.InputMaybe<Types.Scalars['String']['input']>;
	password?: Types.InputMaybe<Types.Scalars['String']['input']>;
	magicLinkToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type RefreshTokenMutation = {
	__typename?: 'Mutation';
	signIn:
		| { __typename?: 'BadRequest' }
		| { __typename?: 'Forbidden'; message: string }
		| { __typename?: 'SignInResult'; idToken: string; expiresIn: number };
};

export const RefreshTokenDocument = gql`
	mutation RefreshToken(
		$username: String
		$password: String
		$magicLinkToken: String
	) {
		signIn(
			input: {
				username: $username
				password: $password
				magicLinkToken: $magicLinkToken
			}
		) {
			... on Forbidden {
				message
			}
			... on SignInResult {
				idToken
				expiresIn
			}
		}
	}
`;
export type RefreshTokenMutationFn = Apollo.MutationFunction<
	RefreshTokenMutation,
	RefreshTokenMutationVariables
>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      magicLinkToken: // value for 'magicLinkToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RefreshTokenMutation,
		RefreshTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RefreshTokenMutation,
		RefreshTokenMutationVariables
	>(RefreshTokenDocument, options);
}
export type RefreshTokenMutationHookResult = ReturnType<
	typeof useRefreshTokenMutation
>;
export type RefreshTokenMutationResult =
	Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
	RefreshTokenMutation,
	RefreshTokenMutationVariables
>;
